export default __webpack_public_path__ + "static/2-0946908510b38e533e12edd14e718361.gif";